exports = module.exports = require("../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vux-slider > .vux-indicator {\n  position: absolute !important;\n  bottom: -0.1rem !important;\n  left: 0rem !important;\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n}\n.vux-slider > .vux-indicator > a > .vux-icon-dot,\n.vux-slider .vux-indicator-right > a > .vux-icon-dot {\n  width: 0.16rem !important;\n  height: 0.16rem !important;\n  background: #fff;\n  border: 1px solid #979797 !important;\n}\n", ""]);

// exports
